// extracted by mini-css-extract-plugin
module.exports = {"cms-page":"Cms_cms-page__r3Wai"};